export const hasWindowObject = typeof window !== "undefined";

export const isTouchScreen =
  hasWindowObject && window.matchMedia("(pointer: coarse)").matches;
